(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon-static/assets/javascripts/distribution-display.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon-static/assets/javascripts/distribution-display.js');
"use strict";

const {
  EventTypeId
} = svs.components.sportinfo.common.constants;
const {
  buttonChoices
} = svs.components.sport.tipsenShared;
const {
  getProductDistribution
} = svs.components.tipsen.couponStatic.utils;
const {
  useBetEvent
} = svs.components.sportinfo.matchInfoHooks;
const DistributionDisplay = _ref => {
  let {
    distributionChoice,
    eventNumber,
    drawNumber,
    productId,
    selectedCouponChoice
  } = _ref;
  const {
    betEvent,
    eventStatistics
  } = useBetEvent({
    productId,
    drawNumber,
    eventNumber
  });
  const isGoalCount = (betEvent === null || betEvent === void 0 ? void 0 : betEvent.eventTypeId) === EventTypeId.GOAL_COUNT;
  const productDistribution = getProductDistribution({
    eventStatistics,
    productId,
    drawNumber
  });
  return React.createElement("div", {
    className: "pg_coupon_static__event_distribution ".concat(isGoalCount ? 'fc-fulltraff-400' : '')
  }, selectedCouponChoice === buttonChoices.SYSTEM_DISTRIBUTION && distributionChoice[eventNumber - 1].map((outcome, i) => {
    const key = "".concat(i, "_").concat(outcome);
    return React.createElement("span", {
      className: "pg_coupon_static__event_distribution__text",
      key: key
    }, outcome);
  }), selectedCouponChoice === buttonChoices.PEOPLE_DISTRIBUTION && productDistribution.current.value.map((outcome, i) => {
    const key = "".concat(i, "_").concat(outcome);
    return React.createElement("span", {
      className: "pg_coupon_static__event_desc_text",
      key: key
    }, outcome);
  }));
};
setGlobal('svs.components.tipsen.couponStatic.DistributionDisplay', DistributionDisplay);

 })(window);